// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".awsui_root_xttbq_pgwjg_99:not(#\\9){position:absolute !important;inset-block-start:-9999px !important;inset-inline-start:-9999px !important}\n", ""]);
// Exports
module.exports = exports;
